module.exports = __webpack_public_path__ + "pg.svg?5c17391e78b57ac623cff8401a4e303a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/pg.svg
// module id = 1560
// module chunks = 0